const emailLabelInput = {
  id: 'globals.email',
};

const passwordLabelInput = {
  id: 'globals.password',
};

const rememberMeText = {
  id: 'login.rememberMe',
};

const forgotPassword = {
  id: 'login.forgotPassword',
};
const createAccount = {
  id: 'login.createAccount',
};
const createNow = {
  id: 'login.createNow',
};
const submitButtonText = {
  id: 'login.submitButtonText',
};

const title = {
  id: 'login.title',
};

const textIds = {
  emailLabelInput,
  passwordLabelInput,
  rememberMeText,
  submitButtonText,
  title,
  forgotPassword,
  createAccount,
  createNow,
};

export default textIds;
